<template>
  <div class="main">
    <div class="left-bar">
      <sub-left-menu :menus="menus" :selectTrace="selectTrace"></sub-left-menu>
      <products-ranking topic="最新产品" :products="newProducts" v-if="newProducts.length"></products-ranking>
      <products-ranking topic="相关产品" :products="relativeProducts" v-if="relativeProducts.length"></products-ranking>
    </div>
    <div class="sub-main">
      <breadcrumb :paths="selectTrace"></breadcrumb>
      <div class="article-detail">
        <div class="article-name">{{article.title}}</div>
        <!-- <div class="article-brief">{{article.brief}}</div> -->
        <div class="article-content" v-html="article.content"></div>
        <div class="article-brief" v-if="article.file">附件：<a :href="'http://file.teamcorp.cn/wo_de/product/'+ article.file" :download="article.file">{{article.file}}</a></div> 
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/widgets/public/Breadcrumb'
import SubLeftMenu from '@/widgets/public/SubLeftMenu'
import productsRanking from '@/widgets/product/Ranking'

import service from '@/utils/service'
// import tools from '@/utils/base'

export default {
  components: { Breadcrumb, SubLeftMenu, productsRanking },
  data () {
    return {
      classifyTree: [],
      currentNode: [],
      article: {},
      newProducts: [],
      relativeProducts: []
    }
  },
  computed: {
    menus () {
      let menus = []
      for (var i in this.classifyTree) {
        let node = this.toMenuItem(this.classifyTree[i])
        if ('children' in this.classifyTree[i]) {
          let menuItem = []
          for (var j in this.classifyTree[i]['children']) {
            menuItem.push(this.toMenuItem(this.classifyTree[i]['children'][j]))
          }
          node['children'] = menuItem
        }
        menus.push(node)
      }
      return menus
    },
    selectTrace () {
      let selectTrace = []
      for (var i in this.currentNode) {
        selectTrace.push(this.toMenuItem(this.currentNode[i]))
      }
      return selectTrace
    }
  },
  created () {
    this.loadArticle()
    this.loadNewProducts()
  },
  methods: {
    loadMenu () {
      let _this = this
      service.get('/article/classifyTree').then(function (response) {
        _this.classifyTree = response
      })
    },
    loadPathTrace () {
      let _this = this
      service.get('/article/getTrace?classifyId=' + this.article.classifyId).then(function (response) {
        _this.currentNode = response
      })
    },
    loadArticle () {
      let _this = this
      service.get('/article/detail?articleId=' + this.$route.params.id).then(function (response) {
        _this.article = response
        _this.refreshMenus()
      })
    },
    refreshMenus () {
      this.loadPathTrace()
      this.loadMenu()
    },
    loadNewProducts () {
      let _this = this
      service.get('/product/newProducts').then(function (response) {
        _this.newProducts = response
      })
    },
    toMenuItem (node) {
      return {'nodeId': node.nodeId, 'name': node.label, 'url': '/article?classifyId=' + node.nodeId}
    }
  }
}
</script>

<style scoped>
.article-detail {
  padding: 30px;
  margin: 4px 0 0 0;
  background: #ffffff;
    min-height:1430px;
}
.article-name {
  font-size: 22px;
  color: #333333;
  text-align: center;
  margin: 15px 0;
    line-height: 150%;
}
.article-brief {
  font-size: 14px;
  color: #888;
  padding-bottom: 15px;
}
.article-content p,span{
  font-size:15px;
  font-family: "宋体";
  line-height:27px;
}
</style>



// WEBPACK FOOTER //
// src/views/article/Detail.vue